import React from "react";

const LoadingSpinner = ({ label = 'Loading' }) => {
  return (
    <div className="spinner__container">
        <div className="spinner"></div>
        <p className="spinner__text">{label}</p>
    </div>
  )
}

export default LoadingSpinner
